/**
 * Created by matheusmorett on 22/08/17.
 */
import Alert from './Alert';
export default Alert;
